import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'translations/hooks';

export const NoScanSiteConfigured = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-y-6 text-center">
      <InfoCircleOutlined className="text-2xl" />
      <h1 className="max-w-xs text-lg">{t('home.noScanSiteConfigured')}</h1>
    </div>
  );
};
